import * as React from 'react';
import { style } from './RecommendationSection';
import { PriceWithDiscount } from './PriceWithDiscount';
import { Link } from '../Link';
import { CTA } from '../CTA';
import { __ } from '../../helpers/TranslationService';

interface IProps {
    data: any;
    discountThreshold: number;
    showDescription?: boolean;
}

export function recommendationWithDesc(props: IProps) {
    return props.data.map((harbour) => {
        const priceProps = {
            price: harbour.priceDualCurrency || harbour.price,
            discount: harbour.discount,
            currency: harbour.dualCurrency || harbour.currency,
            discountThreshold: harbour.discountThreshold,
        };
        const teaserText = harbour?.title ? harbour.title.split(',')[0].trim() : harbour.title;
        const teaserTitle = (
            <div style={style.teaserTitle} dangerouslySetInnerHTML={{ __html: teaserText }} />
        );
        const child = (
            <div style={style.card} className="teaserContentWrapper">
                {props.showDescription && (
                    <div style={style.cardInfo} className="teaserContentInfo">
                        <div style={style.harbourListDescWrapper}>
                            <div className="teaserDescription overflow-ellipsis--multi-line noJustifiedText">
                                {harbour.description}
                            </div>
                        </div>
                    </div>
                )}
                <div
                    className={`teaserPriceCTA ${
                        !props.showDescription ? 'teaserPriceCTAWithoutDescription' : ''
                    }`}
                >
                    <PriceWithDiscount {...priceProps} />
                    <CTA
                        className="onlyDesktop"
                        wrapperStyle={{
                            width: '345px',
                            margin: '14px auto',
                            padding: '11px 5px',
                            fontSize: '15px',
                        }}
                    >
                        {__('%s Cruises', 'dreamlines', teaserText)}
                    </CTA>
                </div>
            </div>
        );

        return {
            teaserTitle,
            imageSrc: harbour.image,
            imageAlt: harbour.title,
            child: child,
            url: harbour.url,
            shipImage: harbour.image,
        };
    });
}
